import { css } from "styled-components";
export const placeholder = css(["&::-moz-placeholder{opacity:1;}&::placeholder{color:", ";user-select:none;}&:placeholder-shown{text-overflow:ellipsis;}"], p => p.theme.colors.placeholder);